import { getMyNetworkingByKey } from '../../myNetworkingSelectors';
import { appendId } from '../../myNetworkingUtils';
import { STORE_MASK_CHATGROUPS_FILES_LIST_GET } from './filesuploadItemsConstants';

// eslint-disable-next-line import/prefer-default-export
export const getFilesList = (groupId) => {
  const selectorKey = appendId(STORE_MASK_CHATGROUPS_FILES_LIST_GET, groupId);
  return getMyNetworkingByKey(selectorKey) ?? [];
};
